import { createAction } from '@reduxjs/toolkit';

import type { ConcentrationViolationDataResponse } from 'commons/modules/service/sales-practices';
import type LabelValue from 'commons/modules/label-value';

import { createReportSlice } from './reportStore';
import type { RootState } from './configureStore';

const initialFilters = {
  alertType: '',
  institute: '',
  client: '',
  issuer: '',
  status: '',
};

const initData = {
  issuerData: [],
  marketData: [],
  productData: [],
};

// ======================================================
// 🔹 Acciones custom para operationSales
// ======================================================
export const setOperationData =
  createAction<ConcentrationViolationDataResponse | null>(
    'operationSales/setOperationData',
  );
export const setOriginalData =
  createAction<ConcentrationViolationDataResponse | null>(
    'operationSales/setOriginalData',
  );
export const setOperationQuery = createAction(
  'operationSales/setOperationQuery',
);
export const setGroupedBy = createAction<LabelValue | null>(
  'operationSales/setGroupedBy',
);
export const resetPage = createAction('operationSales/resetPage');

// ======================================================
// 🔹 Slice usando el store genérico
// ======================================================
const slice = createReportSlice<any>(
  'operationSales',
  initialFilters,
  (builder) => {
    builder
      .addCase(setOperationData, (state, action) => {
        state.dataSales = action.payload?.data || initData;
      })
      .addCase(setOriginalData, (state, action) => {
        state.originalData = action.payload?.data || initData;
      })
      .addCase(setOperationQuery, (state) => {
        state.operationQuery = { ...state.filters };
      })
      .addCase(setGroupedBy, (state, action) => {
        state.groupedBy = action.payload;
      })
      .addCase(resetPage, (state) => {
        state.dataSales = initData;
        state.page = 1;
        state.pageSize = 50;
      });
  },
);

// ======================================================
// 🔹 Inicialización de campos custom
// ======================================================
const baseReducer = slice.reducer;
export default (state: any, action: any) => {
  if (state === undefined) {
    return baseReducer(
      {
        ...baseReducer(undefined, { type: '@@INIT' }),
        dataSales: initData,
        originalData: initData,
        operationQuery: { ...initialFilters },
        groupedBy: null,
      },
      action,
    );
  }
  return baseReducer(state, action);
};

// ======================================================
// 🔹 Selectores custom (los genéricos están en useReportStore)
// ======================================================
// Selectores específicos de operationSales
export const getOperationData = (state: RootState) =>
  state.entities.operationSales.dataSales || initData;
export const getOriginalData = (state: RootState) =>
  state.entities.operationSales.originalData || initData;
export const getGroupedBy = (state: RootState) =>
  state.entities.operationSales.groupedBy || null;
